import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Chart, Widget } from "../../../Constant";
import TotalSale from "./TotalSale";
import TotalProject from "./TotalProject";
import TotalProduct from "./TotalProduct";
import MonthlyHistory from "./MonthlyHistory";
import SkillStatus from "./SkillStatus";
import OrderStatus from "./OrderStatus";
import LiveProducts from "./LiveProducts";
import Turnover from "./Turnover";
import CryptocurrencyPrices from "./CryptocurrencyPrices";
import CryptoAnnotations from "./CryptoAnnotations";
import StockMarket from "./StockMarket";
import Finance from "./Finance";
import OrderStatus2 from "./OrderStatus2";
import MonthlySales from "./MonthlySales";
import Uses from "./Uses";

const ChartWidgetContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Chart} parent={Widget} title={Chart} />
      <Container fluid>
        <Row>
          <TotalSale />
          <TotalProject />
          <TotalProduct />
          <MonthlyHistory />
          <SkillStatus />
          <OrderStatus />
          <LiveProducts />
          <Turnover />
          <CryptocurrencyPrices />
          <CryptoAnnotations/>
          <StockMarket/>
          <Finance/>
          <OrderStatus2/>
          <MonthlySales/>
          <Uses/>
        </Row>
      </Container>
    </>
  );
};

export default ChartWidgetContainer;
